import { render, staticRenderFns } from "./EdicaoDocumentosListagem.vue?vue&type=template&id=053e8615"
import script from "./EdicaoDocumentosListagem.vue?vue&type=script&lang=js"
export * from "./EdicaoDocumentosListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports